module.exports = __webpack_public_path__ + "img/home-banner.80652650.png";